module.exports = __webpack_public_path__ + "assets/media/gradient-arrow-left.d8092af9.svg";